/**
 * @generated SignedSource<<47a00c01031fd2f00778c4ee89353371>>
 * @relayHash 6b63ab130d784f46de45b14a17fac294
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6b63ab130d784f46de45b14a17fac294

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type useMyChatAssignmentChangedSubscription$variables = {
  connections: ReadonlyArray<string>;
};
export type useMyChatAssignmentChangedSubscription$data = {
  readonly myChatAssignmentChanged: {
    readonly removedFromMe: {
      readonly chatDetails: {
        readonly chatThreadId: string;
      } | null;
      readonly id: string;
    } | null;
    readonly takenByMe: {
      readonly chat: {
        readonly autoTranslationSetting: {
          readonly isLiveTranslationEnabled: boolean;
          readonly targetAgentLanguage: Language;
        } | null;
        readonly greeting: {
          readonly id: string;
          readonly received: boolean;
        };
        readonly lastMessage: {
          readonly content: string | null;
          readonly createdOn: string | null;
          readonly id: string;
        };
        readonly readState: {
          readonly hasUnread: boolean;
          readonly id: string;
          readonly unreadCount: number;
        } | null;
        readonly threadId: string;
      } | null;
      readonly id: string;
      readonly language: Language;
      readonly patient: {
        readonly address: {
          readonly city: string;
          readonly houseNumberStreet: string;
          readonly postalCode: string;
        } | null;
        readonly age: {
          readonly isMajor: boolean;
          readonly years: number;
        };
        readonly birthDate: any;
        readonly country: Country;
        readonly emailAddress: string | null;
        readonly firstName: string;
        readonly gender: Gender;
        readonly id: string;
        readonly lastName: string;
        readonly phoneNumber: string | null;
      };
      readonly questionnaireId: number | null;
      readonly service: Service;
    } | null;
  };
};
export type useMyChatAssignmentChangedSubscription = {
  response: useMyChatAssignmentChangedSubscription$data;
  variables: useMyChatAssignmentChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentChatType",
  "kind": "LinkedField",
  "name": "chat",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threadId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentChatGreeting",
      "kind": "LinkedField",
      "name": "greeting",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "received",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatReadStateType",
      "kind": "LinkedField",
      "name": "readState",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unreadCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUnread",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentChatLastMessage",
      "kind": "LinkedField",
      "name": "lastMessage",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdOn",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatAutoTranslationSettingType",
      "kind": "LinkedField",
      "name": "autoTranslationSetting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLiveTranslationEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "targetAgentLanguage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "houseNumberStreet",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Age",
  "kind": "LinkedField",
  "name": "age",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMajor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "years",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "service",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "questionnaireId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentChatDetails",
  "kind": "LinkedField",
  "name": "chatDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatThreadId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "kind": "Variable",
  "name": "connections",
  "variableName": "connections"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMyChatAssignmentChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyChatAssignmentChangedEvent",
        "kind": "LinkedField",
        "name": "myChatAssignmentChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "takenByMe",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "patient",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/)
                ],
                "storageKey": null
              },
              (v13/*:: as any*/),
              (v14/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "removedFromMe",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v15/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useMyChatAssignmentChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyChatAssignmentChangedEvent",
        "kind": "LinkedField",
        "name": "myChatAssignmentChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "takenByMe",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "patient",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v1/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/)
                ],
                "storageKey": null
              },
              (v13/*:: as any*/),
              (v14/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "takenByMe",
            "handleArgs": [
              (v16/*:: as any*/),
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AppointmentEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "removedFromMe",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  (v16/*:: as any*/)
                ]
              },
              (v15/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6b63ab130d784f46de45b14a17fac294",
    "metadata": {},
    "name": "useMyChatAssignmentChangedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "e9e5c49db91b227d5fdc7f567d1331ab";

export default node;
